// @flow

import * as React from 'react';
import {List} from '../../core/List/List';
import {ListItem} from '../../core/List/ListItem';

type ZeroDecimalCurrenciesProps = {|
  entries: Array<string>,
  children?: React.Node,
|};

export const ZeroDecimalCurrencies = ({
  entries,
}: ZeroDecimalCurrenciesProps) => {
  if (!entries) {
    return null;
  }

  return (
    <List columns={2}>
      {entries.map((c) => (
        <ListItem key={c}>{c.toUpperCase()}</ListItem>
      ))}
    </List>
  );
};
